// @flow

import _ from 'lodash';
import React, { useEffect } from 'react';
import { TextField } from '@shopify/polaris';
import { RenderLabelTooltip } from './render-label-tooltip';

export const RenderTextField = (field: Object) => {
  const { input } = field;
  let { value } = input;
  value = _.isNil(value) ? value : value.toString();

  useEffect(() => {
    return () => {
      field.onUnmount && field.onUnmount();
    };
  }, []);

  return (
    <div>
      {field.tooltip && <RenderLabelTooltip label={field.label} tooltip={field.tooltip} />}
      <TextField
        id={field.input.name}
        value={value}
        type={field.type}
        min={field.min}
        max={field.max}
        label={!field.tooltip ? field.label : null}
        requiredIndicator={true}
        disabled={field.disabled}
        onChange={field.input.onChange}
        onFocus={field.input.onFocus}
        placeholder={field.placeholder ? field.placeholder : ''}
        error={!!field.meta.error && !!field.meta.touched ? field.meta.error : ''}
        onBlur={field.input.onBlur}
        suffix={field.suffix}
        {...field.anotherProps}
      />
    </div>
  );
};
